<head>

</head>
<body>
  <div class="intro">
    <div class="container">
      <br>


      <!-- Delete Form -->
      <!-- Form -->
      <div *ngIf="show_businessDelete_form===true">
        <!-- Title -->
        <h3>
          <br><br><br>
          <span id="title" class="pacificofont"><b><i>Delete Business</i></b></span>
          <br><br><br>
        </h3>
        <!-- Title -->
        <div id="model_popup" class="fancy">
          <p id="delete" style="text-align:center;font-size:
            22px;"><b>Are You Sure You Want to Delete Business {{
              businessEditName }} </b></p><br><hr>
          <button style="margin-left:100px;width:80px" id="delete_button"
            (click)="onClose()" type="button"
            class="btn
            btn-outline-primary">Cancel</button>
          <button style="margin-left:150px;" id="delete_button"
            (click)="deleteBusiness()" type="button"
            class="btn
            btn-outline-danger">Delete</button>
        </div>
      </div>
      <!-- Delete Form -->


      <!-- Add Form -->
      <div *ngIf="show_businessAdd_form === true">
        <!-- Title -->
        <h3>
          <br><br><br>
          <span id="title" class="pacificofont"><b><i>Add Business</i></b></span>
          <br><br><br>
        </h3>
        <!-- Title -->


        <!-- Form -->
        <form id=businessAddForm #businessAddForm="ngForm"
          (ngSubmit)="addBusiness(businessAddForm)">

          <div>

            <!-- Close Icon -->
            <p onmouseover="" style="cursor:
              pointer;text-align:right;font-size:40px;"><a
                (click)="onClose()" style="color:black" class="close">&times;</a></p>
            <!-- Close Icon -->


            <!-- Business Name -->
            <div class="form-group">
              <label id="input_label"
                for="businessName">Name</label>
              <input #businessName="ngModel"
                type="text" class="form-control"
                placeholder="Enter Business Name"
                id="businessName"
                list="businessList"
                aria-describedby="businessName" ngModel
                name="businessName">
              <datalist id="businessList">
                <option *ngFor="let business of businessList">{{business.businessName}}</option>
              </datalist>
            </div>
            <!-- Business Name -->

            <!-- Submit Button -->
            <button id="submit_button" type="submit"
              [disabled]="businessAddForm.invalid" class="btn
              btn-danger">Add</button>
            <!-- Submit Button -->



          </div>
        </form>
        <!-- Form -->
      </div>
      <!-- Add Form -->


      <!-- Edit Form -->
      <div *ngIf="show_businessEdit_form === true">
        <!-- Title -->
        <h3>
          <br><br><br>
          <span id="title" class="pacificofont"><b><i>Edit Business</i></b></span>
          <br><br><br>
        </h3>
        <!-- Title -->


        <!-- Form -->
        <form id=businessEditForm #businessEditForm="ngForm"
          (ngSubmit)="editBusiness(businessEditForm)">

          <div>

            <!-- Close Icon -->
            <p onmouseover="" style="cursor:
              pointer;text-align:right;font-size:40px;"><a
                (click)="onClose()" style="color:black" class="close">&times;</a></p>
            <!-- Close Icon -->


            <!-- Business Name -->
            <div class="form-group">
              <label id="input_label"
                for="businessName">Name</label>
              <input #businessName="ngModel"
                type="text" class="form-control"
                placeholder={{businessEditName}}
                id="businessName"
                autocomplete="off"
                aria-describedby="businessName" ngModel
                name="businessName">
              <!-- <span id="input_label" *ngIf="businessName.invalid &&
              businessName.touched"
                  style="color:red"><b>**Invalid Username Format</b></span> -->
            </div>
            <!-- Business Name -->

            <!-- Submit Button -->
            <button id="submit_button" type="submit"
              [disabled]="businessEditForm.invalid" class="btn
              btn-danger">Edit</button>
            <!-- Submit Button -->



          </div>
        </form>
        <!-- Form -->
      </div>
      <!-- Edit Form -->


      <!-- Business List -->
      <div *ngIf="show_businessEdit_form === false && show_businessAdd_form ===
        false && show_businessDelete_form===false">

        <!-- Title -->
        <h2>
          <span style="position:relative;margin-left:450px;color:white"
            class="pacificofont"><b><i>{{ title|titlecase }}</i></b></span>
        </h2>
        <!-- Title -->


        <!-- Search Bar -->
        <div class="form-group">
          <input id="searchBar" type="text" class="form-control"
            [(ngModel)]="text"
            placeholder="Search Your Business">
        </div>
        <!-- Search Bar -->


        <!-- Add New User Button -->
        <button style="position:relative;bottom:40px;margin-left:1000px;"
          type="button" class="btn btn-info add-new"
          (click)=addBusinessForm()><i class="fa fa-plus"></i> Add New</button>
        <!-- Add New User Button -->


        <!-- Condition for Business List -->
        <div *ngIf="text === '';then content else other_content"></div>
        <!-- Condition for Business List -->


        <!-- Pagination List of Business -->
        <ng-template #content>

          <div>
            <ul class="list-group" *ngFor="let business of
              businessList |
              paginate
              : {id :
              'listing_pagination',
              itemsPerPage : 8,
              currentPage : page,
              totalItems : totalRecords}">

              <li class="list-group-item d-flex justify-content-between
                align-items-center">
                <span>
                  <a href="/customers/{{
                    business.businessId }}">
                    {{business.businessName}}</a>
                </span> <span><a onmouseover="" style="cursor: pointer;color:
                    #FFC107;"
                    class="edit"
                    title="Edit" data-toggle="tooltip"
                    (click)="editBusinessForm(business)"><i
                      class="material-icons">&#xE254;</i></a>&nbsp;
                  <a onmouseover="" style="cursor: pointer;color: #E34724;"
                    class="delete"
                    title="Delete" data-toggle="tooltip"
                    (click)="deleteBusinessForm(business)"><i
                      class="material-icons">&#xE872;</i></a>&nbsp;
                  <a href="/piechart/{{
                    business.businessId }}" onmouseover="" style="cursor:
                    pointer;color:blue;"
                    class="Chart"
                    title="Chart" data-toggle="tooltip"><i
                      class="material-icons">&#xe6c5;</i></a>
                </span>
                <!-- <app-customers-page [bid]="business.businessId"></app-customers-page> -->
              </li>
            </ul>
          </div>
          <div>
            <pagination-controls style="color:white;" id="listing_pagination"
              (pageChange)="page=
              $event"></pagination-controls>
          </div>
        </ng-template>
        <!-- Pagination List of Business -->


        <!-- Searching List of Business -->
        <ng-template #other_content>
          <div>
            <ul class="list-group" *ngFor="let business of
              businessList.slice().reverse() | filter:text">

              <li class="list-group-item d-flex justify-content-between
                align-items-center">
                <span>
                  <a href="/customers/{{
                    business.businessId }}">
                    {{business.businessName}}</a>
                </span> <span><a onmouseover="" style="cursor: pointer;color:
                    #FFC107;"
                    class="edit"
                    title="Edit" data-toggle="tooltip"
                    (click)="editBusinessForm(business)"><i
                      class="material-icons">&#xE254;</i></a>&nbsp;&nbsp;&nbsp;
                  <a onmouseover="" style="cursor: pointer;color: #E34724;"
                    class="delete"
                    title="Delete" data-toggle="tooltip"
                    (click)="deleteBusinessForm(business)"><i
                      class="material-icons">&#xE872;</i></a>
                </span>
              </li>
            </ul>
          </div>
        </ng-template>
        <!-- Searching List of Business -->
      </div>
      <!-- Business List -->

    </div>
  </div>
</body>
<router-outlet></router-outlet>